<template>
  <div class="onlineReserve-add">
    <van-row type="flex" justify="center" class="row-title">
      <van-col span="24" class="col-title">
        <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="friends-o">
          不动产委托证明
        </van-notice-bar>
      </van-col>
    </van-row>
    <div
      v-for="(delegate,delegateIndex) in delegateList"
      :key="delegate.id"
      :name="delegateIndex"
    >
      <van-row type="flex" justify="center" class="row-tip">
        <van-col span="24" class="col-tip">
          <van-divider
            :style="{ color: '#999', borderColor: '#999', padding: '0 16px' }"
          >
            委托证明信息
          </van-divider>
        </van-col>
      </van-row>
      <van-row type="flex" justify="center" class="row-tip">
        <van-col span="24" class="col-tip">
          <van-cell-group inset>
            <van-field
              :value="delegate.applicationNumber"
              name="申请委托编号"
              label="申请委托编号"
              placeholder="申请委托编号"
              readonly
            />
            <van-field
              :value="delegate.name"
              name="委托人名称"
              label="委托人名称"
              placeholder="委托人名称"
              readonly
            />
            <van-field
              :value="delegate.applicationTime"
              name="委托申请时间"
              label="委托申请时间"
              placeholder="委托申请时间"
              readonly
            />
            <van-field
              :value="delegate.agentName"
              name="受托人名称"
              label="受托人名称"
              placeholder="受托人名称"
              readonly
            />
            <van-field
              :value="delegate.completionTime"
              left-icon="warning-o"
              name="办结时间"
              label="完结时间"
              placeholder="未办结"
              readonly
            />
          </van-cell-group>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script type="text/javascript">
import { getDelegateList } from '@/api/deletate'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      AssignorId: '',
      delegateList: []
    }
  },
  computed: {
    ...mapGetters(['webUserInfo'])
  },
  mounted() {
    console.info(this.webUserInfo)
    this.AssignorId = this.webUserInfo.id
    this.loadDelegateList()
  },
  methods: {
    loadDelegateList() {
      getDelegateList({ assignorId: this.AssignorId }).then(response => {
        console.info(response.data)
        this.delegateList = response.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .onlineReserve-add{
    min-height: 100vh;
    background-color: #F1F0F8;
    .col-tip{
      p{
        margin-left: 5px;
        font-weight: bold;
        font-size: 0.8em;
      }
    };
    .row-button{
      margin-top: 20px;
    }
    .row-show{
      margin-top: 16px;
      .col-show{
        .reser-content{
          padding: 5px 0;
          p{
            margin: 0 16px 0;
            font-size: 0.8em;
            color: #666;
          }
        }
      }
    }
    .row-button{
      margin-top: 50px;
    }
  }
